import { http } from "../http"

// ── 客单价下钻 ────────────────────────────────

export interface AverageOrderTrendItem {
  date: string
  averageAmount: number
}

export interface AverageOrderCityItem {
  cityName: string
  averageAmount: number
}

export interface AverageOrderData {
  todayAmount: number
  comparisonRate: number | null
  trend: AverageOrderTrendItem[]
  cities: AverageOrderCityItem[]
}

// ── 门店下钻汇总 ──────────────────────────────

export interface SalesStoreCategoryShare {
  categoryId: number | null
  categoryName: string
  salesAmount: number
  percentage: number
}

export interface SalesStoreTrendItem {
  date: string
  salesAmount: number
}

export interface SalesStoreSummaryData {
  salesAmount: number
  salesAmountCompareRate: number | null
  customerUnitPrice: number
  customerUnitPriceCompareRate: number | null
  salesNumber: number
  salesNumberCompareRate: number | null
  grossProfitRate: number
  grossProfitRateCompareRate: number | null
  floorEfficiency: number | null
  floorEfficiencyCompareRate: number | null
  categoryShares: SalesStoreCategoryShare[]
  salesTrend: SalesStoreTrendItem[]
}

// ── 订单详情 ──────────────────────────────────

export interface OrderItemData {
  orderItemId?: number | string
  productName?: string
  unitPrice?: number
  quantity?: number
  subtotal?: number
}

export interface OrderDetailData {
  orderId?: number | string
  orderNo?: string
  storeId?: number
  storeName?: string
  orderTime?: string
  paymentMethod?: string
  memberName?: string
  cashierName?: string
  amount?: number
  items?: OrderItemData[]
}

// ── 销售品类占比下钻 ──────────────────────────

export interface CategoryShareSubCategory {
  categoryId: number | null
  categoryName: string
  salesAmount: number
  percentage: number
}

export interface CategoryShareProductTop {
  skuId: number
  skuName: string
  salesQuantity: number
  salesAmount: number
}

export interface CategoryShareDrillData {
  salesAmount: number
  salesAmountCompareRate: number | null
  subCategoryShares: CategoryShareSubCategory[]
  productTop: CategoryShareProductTop[]
}

export interface PurchaseStoreCategoryShare {
  categoryId: number | null
  categoryName: string
  purchaseAmount: number
  percentage: number
}

export interface PurchaseStoreProductTop {
  skuId: number
  skuName: string
  quantity: number
  purchaseAmount: number
}

export interface PurchaseStoreSummaryData {
  purchaseAmount: number
  purchaseAmountCompareRate: number | null
  categoryShares: PurchaseStoreCategoryShare[]
  productTop: PurchaseStoreProductTop[]
}

// ── 总销售额下钻 ──────────────────────────────

export interface SalesDrillDownTrendItem {
  statisticDate: string
  salesAmount: number
}

export interface SalesDrillDownCityItem {
  cityName: string
  salesAmount: number
}

export interface SalesDrillDownData {
  totalSales: number
  previousTotalSales: number
  totalSalesComparisonRate: number
  recentSevenDayTrend: SalesDrillDownTrendItem[]
  cityComposition: SalesDrillDownCityItem[]
}

// ── 均销售额下钻 ──────────────────────────────

export interface EfficiencyDrillDownTrendItem {
  statisticDate: string
  averageSalesAmount: number
}

export interface EfficiencyDrillDownCityItem {
  cityName: string
  averageSalesAmount: number
}

export interface SalesEfficiencyDrillDownData {
  efficiencyType: string
  efficiencyName: string
  averageSalesAmount: number
  previousAverageSalesAmount: number
  averageSalesAmountComparisonRate: number
  trend: EfficiencyDrillDownTrendItem[]
  cityComposition: EfficiencyDrillDownCityItem[]
}

// ── API ───────────────────────────────────────

export const drilldownApi = {
  /** 客单价下钻 */
  getAverageOrder() {
    return http.post<AverageOrderData>("/miss-statistics/dataDetailScreen/averageOrder")
  },

  /** 门店下钻汇总 */
  getSalesStoreSummary(storeId: number) {
    return http.post<SalesStoreSummaryData>("/miss-statistics/dataDetailScreen/salesStoreSummary", { storeId })
  },

  /** 订单详情 */
  getOrderDetail(orderId: number | string) {
    return http.get<OrderDetailData>(`/miss-statistics/dataScreen/orderDetail/${encodeURIComponent(orderId)}`)
  },

  /** 品类占比下钻 */
  getCategoryShareDrill(categoryId: number | null) {
    return http.post<CategoryShareDrillData>("/miss-statistics/dataDetailScreen/categoryShareDrill", { categoryId })
  },

  /** 销售门店一级品类下钻；“其它”传 categoryId: null */
  getCategoryDrill(params: { storeId: number; categoryId: number | null }) {
    return http.post<CategoryShareDrillData>(
      "/miss-statistics/dataDetailScreen/categoryDrill",
      params
    )
  },

  /** 进货 TOP10 门店下钻汇总 */
  getPurchaseStoreSummary(storeId: number) {
    return http.post<PurchaseStoreSummaryData>(
      "/miss-statistics/dataDetailScreen/purchaseStoreSummary",
      { storeId }
    )
  },

  /** 总销售额下钻 */
  getSalesDrillDown(params: { startDate: string; endDate: string }) {
    return http.post<SalesDrillDownData>("/miss-statistics/dataScreen/salesDrillDown", params)
  },

  /** 均销售额下钻 */
  getSalesEfficiencyDrillDown(params: { startDate: string; endDate: string; efficiencyType: string }) {
    return http.post<SalesEfficiencyDrillDownData>("/miss-statistics/dataScreen/salesEfficiencyDrillDown", params)
  },
}
